import Privacy from '../pages/Privacy';

export const companyTexts = {
  Title: {
    ko: (
      <>주식회사 리마</>        
    ),
    en: (
      <>RIMAHR Co., Ltd.</>        
    )
  },
  Biznumber: {
    ko: (
      <>사업자 등록번호 : 101-86-00141</>        
    ),
    en: (
      <>Business Registration Number: 101-86-00141</>        
    )
  },
  Telnumber: {
    ko: (
      <>전화 : 02-6959-9280</>
    ),
    en: (
      <>Phone: 02-6959-9280</>
    )
  },
  Address: {
    ko: (
      <>주소 : 서울특별시 영등포구 국회대로 62길 21 동성빌딩 7층</>
    ),
    en: (
      <>Address : 7th Floor, Dongsung Building, 21 Gukhoe-daero 62-gil, Yeongdeungpo-gu, Seoul</>
    )
  },
  Privacy: {
    ko: (
      <>개인정보 처리방침</>
    ),
    en: (
      <>Privacy Policy</>
    )
  }
};

export const headMenuTexts = {
  product: {
    ko: '제품',
    en: 'Product',
    halcyon: {
      ko: (<>Halcyon</>),
      en: (<>Halcyon</>)
    },
    zc: {
      ko: (<>PRIMX ZONECENTRAL</>),
      en: (<>PRIMX ZONECENTRAL</>)
    },
    // kosmos: {
    //   ko: (<>1KOSMOS</>),
    //   en: (<>1KOSMOS</>)
    // },
    oit: {
      ko: (<>Proofpoint ObserveIT</>),
      en: (<>Proofpoint ObserveIT</>)
    },
    mobileum: {
      ko: (<>Mobileum</>),
      en: (<>Mobileum</>)
    }
  },
  case: {
    ko: '사례',
    en: 'Case',
  },
  contact: {
    ko: '문의',
    en: 'Contact'
  },
  company: {
    ko: '회사',
    en: 'Company',
    about: {
      ko: '회사소개',
      en: 'About'
    },
    location: {
      ko: '오시는길',
      en: 'Location'
    }
  }
};

export const menuTexts = {
  ko: {
    product: headMenuTexts.product.ko,
    productSub: [
      { label: headMenuTexts.product.halcyon.ko, link: '/product/halcyon' },
      { label: headMenuTexts.product.zc.ko, link: '/product/primx-zc' },
      // { label: headMenuTexts.product.kosmos.ko, link: '/product/1kosmos' },
      { label: headMenuTexts.product.oit.ko, link: '/product/proofpoint-oit' },
      // { label: headMenuTexts.product.mobileum.ko, link: '/product/mobileum' }
    ],
    case: headMenuTexts.case.ko,
    contact: headMenuTexts.contact.ko,
    company: headMenuTexts.company.ko,
    companySub: [
      { label: headMenuTexts.company.about.ko, link: '/company/about' },
      { label: headMenuTexts.company.location.ko, link: '/company/location' }
    ]
  },
  en: {
    product: headMenuTexts.product.en,
    productSub: [
      { label: headMenuTexts.product.halcyon.en, link: '/product/halcyon' },
      { label: headMenuTexts.product.zc.en, link: '/product/primx-zc' },
      // { label: headMenuTexts.product.kosmos.en, link: '/product/1kosmos' },
      { label: headMenuTexts.product.oit.en, link: '/product/proofpoint-oit' },
      // { label: headMenuTexts.product.mobileum.en, link: '/product/mobileum' }
    ],
    case: headMenuTexts.case.en,
    contact: headMenuTexts.contact.en,
    company: headMenuTexts.company.en,
    companySub: [
      { label: headMenuTexts.company.about.en, link: '/company/about' },
      { label: headMenuTexts.company.location.en, link: '/company/location' }
    ]
  }
};

const heroTexts = {
    Title: {
      ko: (
        <>
          <br />IT 보안을 위한 실질적이고 철저한 해결책을 제공하는 회사
        </>        
      ),
      en: (
        <>
          <br />Security Beyond Trust, RIMAHR Co., Ltd.
        </>        
      )
    },
    SubTitle: {
      ko: (
        <>
          주식회사 RIMAHR는 고객사의 IT 사이버 보안 지원으로 기업 가치 증대에 기여하는 회사<br />
          국내 IT 보안 개발 회사들과는 차별화된 세계적으로 검증된 솔루션을 제공하는 전문 기업
        </>
      ),
      en: (
        <>
          RIMAHR Co., Ltd. provides the best global information security products to domestic customers
          <br /> for the value of "RISK MANAGEMENT & HIGH RETURN".
        </>
      )
  }
};

const valueTexts = {
  Corevalue: {
    ko: `RIMAHR의 경영 핵심 가치`,
    en: `Core value`
  },
  Professionalism: {
    ko: `최고 수준의 질적 업무 수행`,
    en: `The highest level of quality work performance`
  },
  Trust: {
    ko: `고객과의 약속 철저한 이행`,
    en: `Thorough fulfillment of promises with customers`
  },
  Integrity: {
    ko: `고객의 기대 충족 추구`,
    en: `Pursuit of meeting customer expectations`
  },
  Respect: {
    ko: `고객의 의견 최대 존중`,
    en: `Maximum respect for customer opinions`
  },
  Fairness: {
    ko: `고객 만족을 통한 성과 공유`,
    en: `Sharing results through customer satisfaction`
  }
};

const futureTexts = {
    Future: {
      ko: `미래`,
      en: `Future`
    },
    Text: {
      ko: (
        <>
          기업가들은 현상 유지를 무시하고, 규칙에 도전하며, 판도를 바꾼다.<br />
          우리는 알아야 한다.
          <br /><br />
          기업가들은 세상을 다르게 본다. 그들은 다른 사람들이 보지 못하는 기회를 포착한다. 그들은 새로운 방식을 모색한다. 그들은 현실 안주를 이용한다.
          <br />
          앞으로도 주식회사 리마는 더 나은 기술과 서비스를 제공함으로써 고객의 가치를 보호하고<br />
          고객에게 믿음을 주는 회사가 되도록 노력하겠습니다.
        </>
      ),
      en: (
        <>
          Entrepreneurs ignore the status quo, challenge the rules and change the game.<br />
          We should know.
          <br /><br />
          Entrepreneurs see things differently. They spot opportunities others don't. They look for new ways of doing things. They take advantage of complacency.
          <br />
          RIMAHR will continue to protect customer value and become a company that gives trust to customers by providing better technology and services.
        </>
      )
  }
};

const locationTexts = {
    Rimahr: {
      ko: (
        <>RIMAHR 오시는 길</>        
      ),
      en: (
        <>RIMAHR Location</>        
      )
    },
    Address: {
      ko: (
        <>주소</>        
      ),
      en: (
        <>Address</>        
      )
    },
    AddressTxt: {
      ko: (
        <>서울특별시 영등포구 국회대로 62길 21 동성빌딩 7층</>
      ),
      en: (
        <>7th Floor, Dongsung Building, 21 Gukhoe-daero 62-gil, Yeongdeungpo-gu, Seoul</>
      )
    },
    Contact: {
      ko: (
        <>연락처</>        
      ),
      en: (
        <>Contact Information</>        
      )
    },
    Tel: {
      ko: (<>TEL</>),
      en: (<>TEL</>)
    },
    Teltext: {
      ko: (<>02-6959-9280</>),
      en: (<>+82-02-6959-9280</>)
    },
    Fax: {
      ko: (<>FAX</>),
      en: (<>FAX</>)
    },
    Faxtext: {
      ko: (<>02-6959-9281</>),
      en: (<>+82-02-6959-9281</>)
    },
    eMail: {
      ko: (<>EMAIL</>),
      en: (<>EMAIL</>)
    },
    eMailtext: {
      ko: (<>tech@rimahr.com</>),
      en: (<>tech@rimahr.com</>)
    },
};

const contactTexts = {
    Title: {
      ko: (
        <>당연히 궁금한 점이 있으시지요?</>        
      ),
      en: (
        <>Of course, you may have questions.</>
      )
    },
    Titlemessage: {
      ko: (
        <>
        제품 기능, 구매, 견적 등에 대한 상세한 문의는 신속히 답변드리겠습니다.<br /><br />
        </>        
      ),
      en: (
        <>
        If you have a product inquiry or a question about features, please fill out the form and send it.<br />
        You can also send a question through email.<br /><br />
        We are waiting for your comments.<br /><br /> 
        </>        
      )
    },
    Contact: {
      ko: (
        <>문의</>        
      ),
      en: (
        <>Contact</>        
      )
    },
    Message: {
      ko: (
        <>문의가 제출되었습니다.</>        
      ),
      en: (
        <>Your inquiry has been submitted.</>        
      )
    },
    labels: {
      ko: {
        company: '회사명',
        email: '이메일',
        phone: '전화번호',  
        inquiry: '문의사항',
        submit: '제출',
        title: '문의'
      },
      en: {
        company: 'Company',
        email: 'Business Email',
        phone: 'Phone Number',
        inquiry: 'Inquiry',
        submit: 'Submit',
        title: 'Contact'
      }
    }
};

export { heroTexts, valueTexts, futureTexts, locationTexts, contactTexts};
